/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import {  Node } from '@msdyn365-commerce-modules/utilities';
import * as React from "react";
import { ILiquidCategoryImageViewProps } from "./liquid-category-image";

export default (props: ILiquidCategoryImageViewProps) => {
  const { heading, categoryImage, imageContainer, headingClass } = props;

  
  return (
    <div className="single-header-2020">
      <Node {...imageContainer}>{categoryImage}</Node>

      {!headingClass ? (
        <div className="inside-xl">
          <div className="lf-title">
            {heading}
          </div>
        </div>   
      ) : null}

    </div>
  );
};
